module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/profile/subscription-change/modals/cancel-subscription/cancel-subscription-modal.scss
// module id = ./web/modern/components/settings/profile/subscription-change/modals/cancel-subscription/cancel-subscription-modal.scss
// module chunks = 0